export default {"src":"/_next/static/media/viewAll.78f5fc78.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};